<template>
  <div>
    <form @submit.prevent="submit">
      <div class="mb-0" v-if="!sinParametros">
        <div class="row mb-2 mt-2">
          <div class="col-xs-12">
            <div class="form-inline">
              <div v-if="createButton && !fechas" class="form-field">
                <button
                  class="btn-success btn--bigger"
                  @click="
                    currentIndex = -1;
                    crear();
                  "
                  type="button"
                >
                  <i class="fa fa-plus"></i>
                  <span>Crear</span>
                </button>
              </div>
              <div v-show="exportable && !fechas" class="form-field">
                <button type="button" @click="exportar" class="btn-primary btn--bigger">
                  <i class="fa fa-file-excel-o"></i>
                  <span>Excel</span>
                </button>
              </div>
              <div v-show="!fechas && pdfExportable" class="form-field">
                <button type="button" @click="exportarPdf" class="btn-danger btn--bigger">
                  <i class="fa fa-file-pdf-o"></i>
                  <span>PDF</span>
                </button>
              </div>
              <label v-if="filterStatus">
                <strong>Estados:</strong>
              </label>
              <label v-if="filterStatus" for="activosKTable">
                <input
                  id="activosKTable"
                  @change="submit"
                  v-model="form.status"
                  type="radio"
                  value="A"
                />
                <span>Activos(as)</span>
              </label>
              <label v-if="filterStatus" for="inactivosKTable">
                <input
                  id="inactivosKTable"
                  @change="submit"
                  v-model="form.status"
                  type="radio"
                  value="I"
                />
                <span>Inactivo(as)</span>
              </label>
              <label v-if="filterStatus" for="todosKTable">
                <input
                  id="todosKTable"
                  @change="submit"
                  v-model="form.status"
                  type="radio"
                  value="T"
                />
                <span>Todos(as)</span>
              </label>
              <div v-if="buscarButton && !fechas" class="form-field">
                <div class="form-group">
                  <input-field
                    stretch
                    @keyup="keyup"
                    v-model="form.search"
                    id="buscar"
                    placeholder="Realice una consulta..."
                  ></input-field>
                  <button type="submit" class="btn-info btn--bigger">
                    <i class="fa fa-search"></i>
                    <span>Buscar</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="fechas">
          <div class="col-xs-12">
            <div class="form-inline">
              <div v-if="createButton" class="form-field">
                <button
                  class="btn-success btn--bigger"
                  @click="
                    currentIndex = -1;
                    crear();
                  "
                  type="button"
                >
                  <i class="fa fa-plus"></i>
                  <span>Crear</span>
                </button>
              </div>
              <div v-show="exportable" class="form-field">
                <button type="button" @click="exportar" class="btn-primary btn--bigger">
                  <i class="fa fa-file-excel-o"></i>
                  <span>Exportar</span>
                </button>
              </div>
              <div v-show="pdfExportable" class="form-field">
                <button type="button" @click="exportarPdf" class="btn-danger btn--bigger">
                  <i class="fa fa-file-pdf-o"></i>
                  <span>PDF</span>
                </button>
              </div>
              <label v-if="fechas">
                <strong>Fecha:</strong>
              </label>
              <label for="hoyKTable" v-if="fechas">
                <input
                  id="hoyKTable"
                  @change="submit"
                  v-model="form.tipo_fecha"
                  type="radio"
                  value="H"
                />
                <span>Hoy</span>
              </label>
              <label for="ayerKTable" v-if="fechas">
                <input
                  id="ayerKTable"
                  @change="submit"
                  v-model="form.tipo_fecha"
                  type="radio"
                  value="A"
                />
                <span>Ayer</span>
              </label>
              <label for="personalizadoKTable" v-if="fechas">
                <input
                  id="personalizadoKTable"
                  @change="cambiarPersonalizado"
                  v-model="form.tipo_fecha"
                  type="radio"
                  value="P"
                />
                <span>Personalizado</span>
              </label>
              <div
                class="form-field"
                v-if="
                  form.tipo_fecha === 'P' || (fechas && form.tipo_fecha === 'P')
                "
              >
                <div class="datepicker-field datepicker-field--stretch">
                  <date-picker
                    type="date"
                    format="dd-MM-yyyy"
                    id="desde"
                    v-model="form.fecha_desde"
                    lang="es"
                  ></date-picker>
                  <label>Desde</label>
                  <span v-if="errores.fecha_desde" class="helper-text text-danger" slot="helper">
                    <strong>{{ errores.fecha_desde[0] }}</strong>
                  </span>
                </div>
              </div>
              <div
                class="form-field"
                v-if="
                  form.tipo_fecha === 'P' || (fechas && form.tipo_fecha === 'P')
                "
              >
                <div class="datepicker-field datepicker-field--stretch">
                  <date-picker
                    type="date"
                    format="dd-MM-yyyy"
                    id="hasta"
                    v-model="form.fecha_hasta"
                    lang="es"
                  ></date-picker>
                  <label>Hasta</label>
                  <span v-if="errores.fecha_hasta" class="helper-text text-danger" slot="helper">
                    <strong>{{ errores.fecha_hasta[0] }}</strong>
                  </span>
                </div>
              </div>
              <div v-if="buscarButton" class="form-field">
                <div class="form-group">
                  <input-field
                    stretch
                    @keyup="keyup"
                    v-model="form.search"
                    id="buscar"
                    placeholder="Realice una consulta..."
                  ></input-field>
                  <button type="submit" class="btn-info btn--bigger">
                    <i class="fa fa-search"></i>
                    <span>Buscar</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="form-inline mb-3 mt-2">
      <p>Registros por página</p>
      <div class="ktable-select">
        <select @change="submit" id="cantidadRegistros" v-model="form.cantidadRegistros">
          <option :value="10">10</option>
          <option :value="30">30</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
      </div>
    </div>
    <div class="table-responsive">
      <table :class="classes" class="table-selectable">
        <thead>
          <tr>
            <th
              v-show="!column.hidden"
              v-for="(column, index) in columns"
              :key="'column' + index"
            >{{ column.display }}</th>
            <th v-if="editButton || deleteButton || buttons.length > 0">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr
            :class="{
              'cursor-pointer': cursorPointer,
              'tr--canceled': row.estado === estadoInactivo,
              'tr--pending': row.estado === 'P',
              'tr--authorized': row.estado === 'F',
              'tr--issued': row.estado === 'I' && estadoInactivo !== 'I'
            }"
            @dblclick="
              currentIndex = index;
              seleccionar(row);
            "
            v-for="(row, index) in rows"
            :key="'row' + index"
          >
            <td v-show="!column.hidden" v-for="(column, ix) in columns" :key="'cell' + index + ix">
              <input-field
                @keyup="emitirInputs(rows)"
                v-model="row[column.value]"
                v-if="
                  column.input &&
                    column.type !== 'checkbox' &&
                    column.type !== 'radio'
                "
                :id="'cell' + index + ix"
                :type="column.type"
              ></input-field>
              <label v-else-if="column.input" :for="'cell' + index + ix">
                <input
                  @change="emitirInputs(rows)"
                  v-model="row[column.value]"
                  :type="column.type"
                  :id="'cell' + index + ix"
                />
                <span></span>
              </label>
              <span v-else v-show="!column.input && !column.image">
                {{ column.prefijo != undefined ? "$" : ""
                }}{{
                column.numeric &&
                row[column.value] !== undefined &&
                row[column.value] !== null
                ? parseFloat(lodash.get(row, column.value)).toLocaleString(
                locale
                )
                : lodash.get(row, column.value)
                }}
              </span>
              <div v-if="column.image && row[column.value] != null" class="img-container">
                <img
                  :src="row[column.value]"
                  :alt="row[column.value]"
                  width="75px"
                />
                <center>
                  <a download :href="row[column.value]" class="btn-info btn--text">
                    <i class="fa fa-download"></i>
                  </a>
                </center>
              </div>
            </td>
            <td class="table-actions" v-if="editButton || deleteButton || buttons.length > 0">
              <button
                v-if="editButton"
                @click="
                  currentIndex = index;
                  editar(row);
                "
                class="btn-info btn--text"
                type="button"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                v-if="deleteButton"
                @click="
                  currentIndex = index;
                  eliminar(row);
                "
                class="btn--text"
                :class="{
                  'btn-danger': row.estado !== estadoInactivo,
                  'btn-success': row.estado === estadoInactivo
                }"
                type="button"
              >
                <i
                  class="fa"
                  :class="{
                    'fa-trash': row.estado !== estadoInactivo,
                    'fa-power-off': row.estado === estadoInactivo
                  }"
                ></i>
              </button>
              <button
                @click="$emit(button.event, row)"
                type="button"
                v-for="(button, index) in buttons"
                v-show="button.event !== 'aprobar' || row.aprobado === 'N'"
                :key="index"
                class="btn--text"
                :class="button.class"
                :tooltip="button.tooltip?button.tooltip:null"
              >
                <i class="fa" :class="button.icon"></i>
                <span v-if="button.text !== ''">{{ button.text }}</span>
              </button>
            </td>
          </tr>
          <tr v-if="rows.length === 0">
            <td
              :colspan="
                columns.length +
                  (editButton || deleteButton || buttons.length > 0 ? 1 : 0)
              "
            >
              <strong>No hay datos.</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="ktable-pagination">
      <p
        class="ktable-pagination__button"
        :disabled="form.currentPage == 0 || form.currentPage == 1"
      >
        <a @click="anteriorPagina" href="#">
          <i class="fa fa-chevron-left"></i>
          <span>Anterior</span>
        </a>
      </p>
      <p
        class="ktable-pagination__button"
        :disabled="form.currentPage == totalPages || totalPages == 1"
      >
        <a @click="siguientePagina" href="#">
          <span>Siguiente</span>
          <i class="fa fa-chevron-right"></i>
        </a>
      </p>
      <p>Páginas</p>
      <div class="ktable-select">
        <select @change="submit" v-model="form.currentPage" id="paginaActual">
          <option :value="0" disabled>...</option>
          <option v-for="i in totalPages" :key="'pages' + i" :value="i">
            {{
            i
            }}
          </option>
        </select>
      </div>
      <p>de {{ totalPages }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    pdfExportable: {
      type: Boolean,
      required: false,
      default: false
    },
    exportable: {
      type: Boolean,
      required: false,
      default: false
    },
    cursorPointer: {
      type: Boolean,
      required: false,
      default: false
    },
    registrosPorPagina: {
      required: false,
      type: Number,
      default: 10
    },
    sinParametros: {
      type: Boolean,
      required: false,
      default: false
    },
    busquedaInicial: {
      type: Boolean,
      required: false,
      default: true
    },
    columns: {
      type: Array,
      default: function() {
        return [];
      },
      required: true
    },
    path: {
      type: String,
      required: true
    },
    filterStatus: {
      type: Boolean,
      default: true
    },
    editButton: {
      type: Boolean,
      default: true
    },
    buttons: {
      required: false,
      default: function() {
        return [];
      }
    },
    deleteButton: {
      type: Boolean,
      default: true
    },
    buscarButton: {
      type: Boolean,
      default: true,
      required: false
    },
    buscarNumero: {
      type: Boolean,
      default: false,
      required: false
    },
    remote: {
      type: Boolean,
      default: true,
      required: false
    },
    classes: Object,
    tipoDocumento: {
      type: String,
      default: null,
      required: false
    },
    keyboard: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function() {
        return {};
      }
    },
    createButton: {
      type: Boolean,
      default: true,
      required: false
    },
    keys: {
      type: Array,
      default: function() {
        return [];
      },
      required: false
    },
    value: {
      required: false,
      default: function() {
        return [];
      }
    },
    fechas: {
      required: false,
      default: false,
      type: Boolean
    },
    tipoFecha: {
      type: String,
      default: "H",
      required: false
    },
    estadoInactivo: {
      type: String,
      required: false,
      default: "I"
    }
  },
  data: function() {
    return {
      locale: locale,
      totalPages: 0,
      rows: [],
      tipos_movimientos_cuentas_contables: [],
      selected_tipo_comprobante: {
        codigo: "T",
        descripcion: "TODOS"
      },
      options_tipo_comprobante: [
        {
          codigo: "T",
          descripcion: "TODOS"
        },
        {
          codigo: "FA",
          descripcion: "FACTURA LOCAL"
        },
        {
          codigo: "FR",
          descripcion: "FACTURA POR REEMBOLSO"
        },
        {
          codigo: "LC",
          descripcion: "LIQUIDACIÓN DE COMPRAS"
        },
        {
          codigo: "NV",
          descripcion: "NOTA DE VENTA"
        },
        {
          codigo: "RI",
          descripcion: "FACTURA RISE"
        }
      ],
      lodash: _,
      form: {
        localidadSearch: "T",
        search: "",
        status: "A",
        cantidadRegistros: this.registrosPorPagina,
        paginate: true,
        currentPage: 0,
        tipo_fecha: null,
        fecha_desde: null,
        fecha_hasta: null,
        tipo_comprobante: "T",
        formato: "T",
        numero_documento: "",
        buscarNumero: false,
        tipo_comprobante_contable: null,
        exportar: "N",
        estado_proveeduria: "T"
      },
      currentIndex: -1,
      resultados: [],
      selectedTipo: null,
      tipos: [],
      errores: {
        fecha_desde: null,
        fecha_hasta: null,
        tipo_comprobante: null
      }
    };
  },
  methods: {
    exportarPdf: function() {
      this.form.exportar = "P";
      let result = {};
      for (let key in this.form) result[key] = this.form[key];
      for (let key in this.params) result[key] = this.params[key];
      let params = this.toParams(result);
      window.open(this.path + params, "_blank");
    },
    mostrarObjeto: function(row, value) {
      let parts = value.split(".");
    },
    cambiarPersonalizado: function() {
      let desde = new Date();
      let hasta = new Date();
      if (this.tipoDocumento !== "FE") desde.setMonth(desde.getMonth() - 1);
      else {
        desde = new Date(desde.getFullYear() + "-01-01 00:00:00");
        hasta = new Date(hasta.getFullYear() + "-12-31 23:59:59");
      }
      this.form.fecha_desde = moment(desde).format("YYYY-MM-DD");
      this.form.fecha_hasta = moment(hasta).format("YYYY-MM-DD");
    },
    anteriorPagina: function() {
      this.form.currentPage--;
      this.loadRows();
    },
    siguientePagina: function() {
      this.form.currentPage++;
      this.loadRows();
    },
    submit: function() {
      this.limpiarErrores();
      if (this.remote) this.loadRows();
    },
    limpiarErrores: function() {
      this.errores.fecha_desde = null;
      this.errores.fecha_hasta = null;
      this.errores.tipo_comprobante = null;
    },
    keyup: function() {
      if (this.keyboard) this.submit();
    },
    loadRows: function(path) {
      this.form.exportar = "N";
      let result = {};
      this.errores = {
        fecha_desde: null,
        fecha_hasta: null
      };
      for (let key in this.form) result[key] = this.form[key];
      for (let key in this.params) result[key] = this.params[key];
      let that = this;
      axios
        .get(
          this.path == null || this.path == undefined
            ? path
            : this.path.replace("undefined", ""),
          {
            params: result
          }
        )
        .then(function(response) {
          let paginator = response.data;
          that.rows = paginator.data;
          that.form.currentPage = paginator.current_page;
          that.totalPages = paginator.last_page;
          if ((path != null || path != undefined) && response.data.length === 0)
            swal("No se han encontrado registros", "Información", "info");
          if (that.form.currentPage > that.totalPages) {
            that.form.currentPage = 1;
            that.loadRows();
          }
          that.actualizarResultados();
        })
        .catch(function(error) {
          let response = error.response;
          if (response !== null && response !== undefined) {
            if (response.status === 422){
              that.errores = response.data.errors;
              that.$emit('errores', that.errores);
            }
            else
              swal("Hubo un error al realizar la consulta.", "Error", "error");
          }
        });
    },
    editar: function(row) {
      this.$emit("editar", row);
    },
    eliminar: function(row) {
      this.$emit("eliminar", row);
    },
    seleccionar: function(row) {
      this.$emit("seleccionar", row);
    },
    crear: function() {
      this.$emit("crear");
    },
    actualizarLista: function(row) {
      if (this.currentIndex === -1) {
        this.currentIndex = 0;
        this.rows.splice(0, 0, row);
      } else this.rows.splice(this.currentIndex, 1, row);
    },
    eliminarFila: function(row) {
      this.rows.splice(this.currentIndex, 1, row);
    },
    mostrarResultados: function(resultados) {
      if (resultados.length > 0) {
        for (let i = 0; i < resultados.length; i++)
          this.resultados.push(resultados[i]);
      }
    },
    cargarTiposMovimientoCuentaContable: function() {
      let that = this;
      axios.get("/api/cargar_tipo_comprobante").then(function(response) {
        that.tipos_movimientos_cuentas_contables = response.data;
      });
    },
    emitirInputs: function(value) {
      if (this.keys.length > 0) {
        for (let i = 0; i < this.rows.length; i++) {
          for (let j = 0; j < this.columns.length; j++) {
            if (
              this.columns[j].input &&
              this.rows[i][this.columns[j].value] !== undefined
            ) {
              let index = -1;
              for (let k = 0; k < this.resultados.length; k++) {
                let existe = true;
                for (let l = 0; l < this.keys.length; l++)
                  if (
                    this.resultados[k][this.keys[l]] !==
                    this.rows[i][this.keys[l]]
                  )
                    existe = false;
                if (existe) {
                  index = k;
                  break;
                }
              }
              let obj = JSON.parse(JSON.stringify(this.rows[i]));
              if (index === -1) this.resultados.push(obj);
              else this.resultados.splice(index, 1, obj);
            }
            this.$emit("input", this.resultados);
          }
        }
      }
    },
    actualizarResultados: function() {
      if (this.resultados.length > 0 && this.keys.length > 0) {
        for (let h = 0; h < this.rows.length; h++) {
          for (let i = 0; i < this.resultados.length; i++) {
            let existe = true;
            for (let j = 0; j < this.keys.length; j++) {
              if (
                this.resultados[i][this.keys[j]] !== this.rows[h][this.keys[j]]
              ) {
                existe = false;
                break;
              }
            }
            if (existe) this.rows.splice(h, 1, this.resultados[i]);
          }
        }
      }
    },
    toParams: function(obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function(a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    exportar: function() {
      this.form.exportar = "S";
      let result = {};
      for (let key in this.form) result[key] = this.form[key];
      for (let key in this.params) result[key] = this.params[key];
      let params = this.toParams(result);
      window.open(this.path + params, "_blank");
    }
  },
  watch: {
    selected_tipo_comprobante: function(value) {
      if (value != null && value != undefined) {
        this.form.tipo_comprobante = value.codigo;
        if (value.codigo != "FA" && value.codigo != "LC")
          this.form.status = "E";
        this.submit();
      } else this.form.tipo_comprobante = null;
    },
    selectedTipo: function(value) {
      if (value != null) {
        this.form.tipo_comprobante_contable = value.tipo;
      } else {
        this.form.tipo_comprobante_contable = null;
      }
    }
  },
  mounted: function() {
    this.form.tipo_fecha = this.tipoFecha;
    if (this.form.tipo_fecha == "P") this.cambiarPersonalizado();
    if (this.tipoDocumento == "PR") {
      this.form.status = "T";
    }
    if (this.busquedaInicial) this.loadRows();
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/element/KTable.vue